export default __webpack_public_path__ + "static/media/CormorantGaramondLight.f57f699f.woff";